import { templates } from '../data/template';
import TemplateCard from '../components/TemplateCard';
import HeroSection from '../components/Hero';
import Contact from './Contact';
import { Star, Cloud } from 'lucide-react';
import {imageUrls} from '../data/AlternateUrls';
import Newsletter from '../components/NewsLetter';
import {FeaturedBlogs} from '../components/FeatureBlog';
import FloatingAd from "../components/HomeAd.tsx";

export default function Home() {
  return (
    <div>{/* Hero Section */}
      <FloatingAd/>
   <HeroSection
        
      />




{/* Call to Action Section */}
<section className="py-16 bg-gradient-to-r from-navy-900 to-blue-900 text-white">
  <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-10 text-center">
    {/* Heading */}
    <h2 className="text-4xl font-extrabold leading-tight text-transparent bg-clip-text bg-white">
      Ready to Build Your Next Project?
    </h2>
    <p className="mt-4 text-lg font-medium max-w-3xl mx-auto text-gray-50">
      Browse through our extensive collection of premium templates and start creating your website today. Whatever your vision, we've got the perfect template to bring it to life.
    </p>

    {/* Stats Section - Minimalist Card Layout */}
    <div className="mt-12 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
      {/* Stat Card 1 */}
      <div className="bg-white/5 p-8 rounded-lg hover:bg-white/10 transition-colors duration-300">
        <div className="bg-gray-50 p-8 rounded-full w-12 h-12 flex items-center justify-center mx-auto">
          <span className="text-xl font-bold text-gray-900">300+</span>
        </div>
        <h4 className="mt-6 text-xl font-medium text-gray-50">Templates Available</h4>
        <p className="mt-2 text-sm text-gray-50/80">
          Explore over 300 templates tailored for any type of business, project, or personal site.
        </p>
      </div>

      {/* Stat Card 2 */}
      <div className="bg-white/5 p-8 rounded-lg hover:bg-white/10 transition-colors duration-300">
        <div className="bg-gray-50 p-8 rounded-full w-12 h-12 flex items-center justify-center mx-auto">
          <span className="text-xl font-bold text-gray-900">99%</span>
        </div>
        <h4 className="mt-6 text-xl font-medium text-gray-50">Customer Satisfaction</h4>
        <p className="mt-2 text-sm text-gray-50/80">
          We have a 99% satisfaction rate based on over 5000 reviews! Our customers love our templates.
        </p>
      </div>

      {/* Stat Card 3 */}
      <div className="bg-white/5 p-8 rounded-lg hover:bg-white/10 transition-colors duration-300">
        <div className="bg-gray-50 p-8 rounded-full w-12 h-12 flex items-center justify-center mx-auto">
          <span className="text-xl font-bold text-gray-900">24/7</span>
        </div>
        <h4 className="mt-6 text-xl font-medium text-gray-50">Support</h4>
        <p className="mt-2 text-sm text-gray-50/80">
          Get help whenever you need it with our around-the-clock customer support for template issues and customization.
        </p>
      </div>
    </div>

    {/* Features Section - Minimalist Grid Layout with Icons */}
    <div className="mt-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
      {/* Feature 1 */}
      <div className="bg-white/5 p-8 rounded-lg hover:bg-white/10 transition-colors duration-300">
        <div className="flex items-center space-x-4">
          <Star className="text-gray-50 w-6 h-6" />
          <h4 className="text-xl font-medium text-gray-50">Premium Quality</h4>
        </div>
        <p className="mt-4 text-sm text-gray-50/80">
          Our templates are crafted with care, offering top-notch design and functionality to ensure your website stands out.
        </p>
      </div>

      {/* Feature 2 */}
      <div className="bg-white/5 p-8 rounded-lg hover:bg-white/10 transition-colors duration-300">
        <div className="flex items-center space-x-4">
          <Cloud className="text-gray-50 w-6 h-6" />
          <h4 className="text-xl font-medium text-gray-50">Cloud-Ready</h4>
        </div>
        <p className="mt-4 text-sm text-gray-50/80">
          Easily deploy your templates to the cloud with minimal setup. We ensure seamless integration with popular platforms.
        </p>
      </div>

      {/* Feature 3 */}
      <div className="bg-white/5 p-8 rounded-lg hover:bg-white/10 transition-colors duration-300">
        <div className="flex items-center space-x-4">
          <Cloud className="text-gray-50 w-6 h-6" />
          <h4 className="text-xl font-medium text-gray-50">Mobile Optimized</h4>
        </div>
        <p className="mt-4 text-sm text-gray-50/80">
          All our templates are fully responsive, ensuring a smooth user experience on all devices, from mobile to desktop.
        </p>
      </div>
    </div>
  </div>
</section>




{/* Features Section */}
<section className="py-24 bg-gradient-to-b from-indigo-50 to-white">
  <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
    {/* Header */}
    <div className="text-center mb-20">
      <h2 className="text-4xl font-bold text-navy-900 tracking-tight">
        Why Our Templates Stand Out
      </h2>
      <p className="mt-4 text-lg text-gray-600 max-w-2xl mx-auto">
        Built with the latest technologies, high performance, and modern designs to empower your projects.
      </p>
    </div>

    {/* Features Grid */}
    <div className="grid gap-20">
      {/* Feature 1: Lightning Fast */}
      <div className="grid md:grid-cols-2 gap-12 items-center">
        <div className="space-y-6 order-1">
          <h3 className="text-3xl font-semibold text-navy-700">Lightning Fast</h3>
          <p className="text-lg text-gray-600 leading-relaxed">
            Our templates are fully optimized for speed, ensuring that your website runs smoothly on any device, providing a seamless user experience.
          </p>
        </div>
        <div className="order-2">
          <img src={imageUrls.military} alt="Fast Loading" className="rounded-xl shadow-lg w-full h-auto object-contain" />
        </div>
      </div>

      {/* Feature 2: Clean Code */}
      <div className="grid md:grid-cols-2 gap-12 items-center">
        <div className="order-2 md:order-1">
          <img src={imageUrls.graphics} alt="Clean Code" className="rounded-xl shadow-lg w-full h-auto object-contain" />
        </div>
        <div className="space-y-6 order-1 md:order-2">
          <h3 className="text-3xl font-semibold text-gray-900">Clean Code</h3>
          <p className="text-lg text-gray-600 leading-relaxed">
            Each template is carefully crafted with clean, well-structured, and easy-to-read code, so you can focus on building great things.
          </p>
        </div>
      </div>

      {/* Feature 3: Premium Design */}
      <div className="grid md:grid-cols-2 gap-12 items-center">
        <div className="space-y-6 order-1">
          <h3 className="text-3xl font-semibold text-gray-900">Premium Design</h3>
          <p className="text-lg text-gray-600 leading-relaxed">
            Modern, professional, and visually stunning designs that enhance your brand's identity and impress your audience.
          </p>
        </div>
        <div className="order-2">
          <img src={imageUrls.musicSchool} alt="Premium Design" className="rounded-xl shadow-lg w-full h-auto object-contain" />
        </div>
      </div>

      {/* Feature 4: Dedicated Support */}
      <div className="grid md:grid-cols-2 gap-12 items-center">
        <div className="order-2 md:order-1">
          <img src={imageUrls.realEstate} alt="Support" className="rounded-xl shadow-lg w-full h-auto object-contain" />
        </div>
        <div className="space-y-6 order-1 md:order-2">
          <h3 className="text-3xl font-semibold text-gray-900">Dedicated Support</h3>
          <p className="text-lg text-gray-600 leading-relaxed">
            We offer continuous, dedicated customer support to assist you in getting the most out of your templates whenever you need help.
          </p>
        </div>
      </div>
    </div>
  </div>
</section>




{/* Templates Grid */}
<section className="py-16 bg-gray-50">
  <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
    <div className="text-center mb-12">
      <h2 className="text-2xl font-bold text-navy-800">Featured Templates</h2>
      <p className="mt-4 text-xl text-gray-600">Start with our most popular designs</p>
    </div>
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
      {templates.slice(0,6).map((template) => (
        <TemplateCard key={template.id} template={template} />
      ))}
    </div>
  </div>
</section>

<FeaturedBlogs/>



{/* Client Testimonials */}
<section className="py-24 bg-navy-900 text-white">
  <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
    <div className="text-center mb-16">
      <span className="text-sm font-semibold text-indigo-400 tracking-wide uppercase">
        Enterprise Validation
      </span>
      <h2 className="mt-2 text-4xl font-bold text-white">
        Trusted by Industry Leaders
      </h2>
    </div>

    <div className="grid grid-cols-1 lg:grid-cols-3 gap-12 relative">
      {/* Decorative Elements */}
      <div className="hidden lg:block absolute inset-0">
        <div className="absolute left-1/3 right-1/3 top-0 h-full w-px bg-white/10"></div>
        <div className="absolute left-2/3 right-0 top-0 h-full w-px bg-white/10"></div>
      </div>

      {/* Testimonial 1 */}
      <div className="relative group">
        <div className="absolute -inset-1 bg-gradient-to-r from-indigo-600 to-blue-600 rounded-2xl opacity-0 group-hover:opacity-20 transition-opacity"></div>
        <div className="relative bg-white/5 p-8 rounded-2xl backdrop-blur-lg border border-white/10">
          <div className="flex items-center gap-4 mb-6">
            <div className="flex-shrink-0">
              <img 
                src="/logos/fortune-500-company.svg" 
                alt="Company logo"
                className="h-12 w-12 object-contain"
              />
            </div>
            <div>
              <p className="font-bold text-lg">Johnathan R.</p>
              <p className="text-sm text-indigo-200">CTO, TechCorp International</p>
            </div>
          </div>
          <blockquote className="text-lg leading-relaxed text-indigo-100">
            "The platform reduced our development cycle by 40% while maintaining 
            enterprise-grade security standards. A game-changer for large-scale 
            digital transformation projects."
          </blockquote>
          <div className="mt-6 border-t border-white/10 pt-6">
            <div className="flex justify-between text-sm">
              <span className="text-indigo-300">Key Impact:</span>
              <span className="font-medium">$2.8M Annual Savings</span>
            </div>
          </div>
        </div>
      </div>

      {/* Testimonial 2 */}
      <div className="relative group">
        <div className="absolute -inset-1 bg-gradient-to-r from-indigo-600 to-blue-600 rounded-2xl opacity-0 group-hover:opacity-20 transition-opacity"></div>
        <div className="relative bg-white/5 p-8 rounded-2xl backdrop-blur-lg border border-white/10">
          <div className="flex items-center gap-4 mb-6">
            <div className="flex-shrink-0">
              <img 
                src="/logos/global-bank.svg" 
                alt="Company logo"
                className="h-12 w-12 object-contain"
              />
            </div>
            <div>
              <p className="font-bold text-lg">Sarah Elizondo</p>
              <p className="text-sm text-indigo-200">Digital Director, First Global Bank</p>
            </div>
          </div>
          <blockquote className="text-lg leading-relaxed text-indigo-100">
            "Implementation across 14 countries was seamless. The solution's 
            compliance-first approach aligned perfectly with our regulatory 
            requirements."
          </blockquote>
          <div className="mt-6 border-t border-white/10 pt-6">
            <div className="flex justify-between text-sm">
              <span className="text-indigo-300">Deployment Scale:</span>
              <span className="font-medium">48 Markets</span>
            </div>
          </div>
        </div>
      </div>

      {/* Testimonial 3 */}
      <div className="relative group">
        <div className="absolute -inset-1 bg-gradient-to-r from-indigo-600 to-blue-600 rounded-2xl opacity-0 group-hover:opacity-20 transition-opacity"></div>
        <div className="relative bg-white/5 p-8 rounded-2xl backdrop-blur-lg border border-white/10">
          <div className="flex items-center gap-4 mb-6">
            <div className="flex-shrink-0">
              <img 
                src="/logos/government-entity.svg" 
                alt="Company logo"
                className="h-12 w-12 object-contain"
              />
            </div>
            <div>
              <p className="font-bold text-lg">Dr. Michael Tan</p>
              <p className="text-sm text-indigo-200">CIO, National Digital Authority</p>
            </div>
          </div>
          <blockquote className="text-lg leading-relaxed text-indigo-100">
            "Achieved 99.98% uptime during critical national infrastructure 
            modernization. The architectural rigor is unmatched in the industry."
          </blockquote>
          <div className="mt-6 border-t border-white/10 pt-6">
            <div className="flex justify-between text-sm">
              <span className="text-indigo-300">System Reliability:</span>
              <span className="font-medium">99.98% Uptime</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    {/* Trust Metrics */}
    <div className="mt-20 grid grid-cols-2 md:grid-cols-4 gap-8 text-center">
      <div className="p-6 border-l border-white/10">
        <div className="text-4xl font-bold text-indigo-400">1500+</div>
        <div className="mt-2 text-sm text-indigo-200">Enterprise Clients</div>
      </div>
      <div className="p-6 border-l border-white/10">
        <div className="text-4xl font-bold text-indigo-400">99.95%</div>
        <div className="mt-2 text-sm text-indigo-200">SLA Compliance</div>
      </div>
      <div className="p-6 border-l border-white/10">
        <div className="text-4xl font-bold text-indigo-400">240%</div>
        <div className="mt-2 text-sm text-indigo-200">Average ROI</div>
      </div>
      <div className="p-6 border-l border-white/10">
        <div className="text-4xl font-bold text-indigo-400">58</div>
        <div className="mt-2 text-sm text-indigo-200">Countries Served</div>
      </div>
    </div>
  </div>
</section>


<Newsletter/>

<Contact/>

    </div>
  );
}